<template>
  <div class="safety">
    <!--1440*664  8.3  9.6  352.8  215.8 -->
    <div class="safety_manage_container column">
      <div class="safety_manage_item item-1" @click="clickChart('1')"
           style="transform: translate(-529.2px, -323.7px) scale(0.25)">
        <gentry :project_id="project_id"></gentry>
      </div>
      <div class="safety_manage_item item-2" @click="clickChart('2')"
           style="transform:translate(-529.2px, -99.6px)  scale(0.25)">
        <ptwclassify :project_id="project_id"></ptwclassify>
      </div>
      <div class="safety_manage_item item-3" @click="clickChart('3')"
           style="transform:translate(-529.2px, 124.5px)  scale(0.25)">
        <ptw :project_id="project_id"></ptw>
      </div>
      <div class="safety_manage_item safety_manage_item_active item-4" @click="clickChart('4')"
           style="transform:translate(5px, -220px) scale(0.5)">
        <manhour style="position: absolute" :project_id="project_id" :total_manhour="total_manhour"></manhour>
      </div>
      <div class="safety_manage_item item-5" @click="clickChart('5')"
           style="transform:translate(-166.8px, 124.5px)  scale(0.25)">
        <training :project_id="project_id"></training>
      </div>
      <div class="safety_manage_item item-6" @click="clickChart('6')"
           style="transform:translate(195.6px, 124.5px)  scale(0.25)">
        <injury :project_id="project_id" :total_manhour="total_manhour"></injury>
      </div>
      <div class="safety_manage_item item-7" @click="clickChart('7')"
           style="transform:translate(558px, -323.7px)  scale(0.25)">
        <check :project_id="project_id"></check>
      </div>
      <div class="safety_manage_item item-8" @click="clickChart('8')"
           style="transform:translate(558px, -99.6px)  scale(0.25);z-index: 999">
        <snc :project_id="project_id"></snc>
      </div>
      <div class="safety_manage_item item-9" @click="clickChart('9')"
           style="transform:translate(558px, 124.5px)  scale(0.25)">
        <checklist :project_id="project_id"></checklist>
      </div>
    </div>
  </div>
</template>

<script>
import gentry from '@/components/safety_manage/gentry'
import ptwclassify from '@/components/safety_manage/ptwclassify'
import ptw from '@/components/safety_manage/proj_ptw'
import manhour from "@/components/safety_manage/total_manhour";
import training from "@/components/safety_manage/training";
import injury from "@/components/safety_manage/injury_record";
import check from '@/components/safety_manage/check'
import snc from "@/components/safety_manage/snc_a";
import checklist from "@/components/safety_manage/checklist";
import staff from '@/components/safety_manage/pro_staff'
import workers from '@/components/safety_manage/workers'
import safety from '@/components/safety_manage/safety'
import equipment from '@/components/safety_manage/equipment'
import spot from '@/components/spot/spot'

import axios from 'axios'

export default {
  name: "safety_manage",
  props: ['project_id'],

  data() {
    return {
      my_project_id: this.project_id,
      tbmCount: [],
      total_manhour: 0,
      tbmEmpty: true,
      nowTime: '',
      startDate: '2018-08-15',
      startTimes: '',
      container: '',
      items: [],
      if_active: [
        {active: false},
        {active: false},
        {active: false},
        {active: true},
        {active: false},
        {active: false},
        {active: false}
      ],
      active_index: 3,
    }
  },
  methods: {
    clickChart(clickIndex) {
      let activeItem = document.querySelector('.safety_manage_container .safety_manage_item_active')
      let activeIndex = activeItem.dataset.order
      let clickItem = this.items[clickIndex - 1]
      if (activeIndex === clickIndex) {
        return
      }
      activeItem.classList.remove('safety_manage_item_active')
      clickItem.classList.add('safety_manage_item_active')
      this._setStyle(clickItem, activeItem)

    },
    _setStyle(el1, el2) {
      let transform1 = el1.style.transform
      let transform2 = el2.style.transform
      el1.style.transform = transform2
      el2.style.transform = transform1
    }
  },
  components: {
    gentry,
    ptwclassify,
    ptw,
    manhour,
    training,
    injury,
    check,
    snc,
    checklist,
    staff,
    workers,
    safety,
    equipment,
    spot
  },
  mounted() {
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    this.items = document.querySelectorAll(('.safety_manage_container .safety_manage_item'))
    for (let i = 0; i < this.items.length; i++) {
      this.items[i].dataset.order = i + 1;
    }
    let postData = {
      project_id: this.my_project_id,
      user: window.localStorage.getItem("token_key"),
      // token: window.localStorage.getItem('token')
      token: "lalala"
    }
    axios.post(this.$store.getters.getCmsServer + "DBProjManhour", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr
      if (errNo == "0") {
        var result = resp.data.result;
        this.total_manhour = parseInt(result[0].manhour)
      } else {
        alert(errStr)
      }
    }).catch(error => {
      alert(error)
    })
  }
}
</script>

<style lang="stylus" scoped>

.safety_manage_item {
  position absolute
  padding 0
  width 98%
  height 130%
  transform scale(0.25)
  text-align center
  transition: all 0.8s
  background rgb(30, 35, 48)
  background-color #31334a
}

.safety
  width 100%
  height 100%

.safety_manage_container.column
  position: relative;
  width: 100%
  height: 100%
  margin: 0 auto;
  font-size 1em
  box-sizing: content-box;

.safety_manage_item_active
  height 132.5%
  width 99.3%
</style>



// WEBPACK FOOTER //
// src/components/safety_manage/safety_manage.vue